import { Video } from "../Video";
import { getShopifyNextImage } from "@lib/getImages";

export function resolveMediaSources(
  src,
  title,
  index,
  width = 1200,
  height = 1800,
  objectFit = "cover",
  layout = "responsive"
) {
  switch (src.mediaContentType) {
    case "IMAGE":
      return getShopifyNextImage(
        src.image.originalSrc,
        width,
        height,
        `(min-width: 45em) calc((100vw - 25rem) / 2), calc(100vw - 5rem)`,
        `Image of ${title}`,
        src.image.placeholder,
        index <= 1,
        objectFit,
        layout
      );

    case "VIDEO":
      return <Video src={src} />;

    default:
      return null;
  }
}
